'use strict';

var style = require('./style');

module.exports = style({
  prop: 'lineHeight',
  key: 'lineHeights'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/line-height.js
// module id = 1060
// module chunks = 168707334958949